import { Splide } from '@splidejs/splide';

// JavaScript code for the custom web component
class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.scrollbarThumb = this.querySelector('.scroll-thumb');
    this.sliderType = this.getAttribute('slider-type') ? this.getAttribute('slider-type') : 'loop';
  }

  connectedCallback() {
    const splide = new Splide(this, {
      perPage: 4,
      perMove: 1,
      type: this.sliderType,
      pagination: false,
      arrows: false,
      breakpoints: {
        1024: {
          perPage: 1,
          padding: { right: '4rem' }
        }
      }
    });

    splide
      .on('mounted move', () => {
        if (!this.scrollbarThumb) return;

        const totalSlides = splide.length || 0;
        const perPage = splide.options.perPage || 1;
        if (totalSlides <= 0) return;

        const visibleRatio = Math.min(1, perPage / totalSlides);
        const visiblePortion = visibleRatio * 100;
        const maxThumbTravel = 100 - visiblePortion;
        const perMove = splide.options.perMove || 1;
        const totalPages = Math.max(Math.ceil((totalSlides - perPage) / perMove) + 1, 1);
        const currentPage = Math.max(Math.min(Math.floor(splide.index / perMove), totalPages - 1), 0);
        const pageProgress = totalPages > 1 ? currentPage / (totalPages - 1) : 0;
        let scrollProgress = maxThumbTravel * pageProgress;
        if (currentPage === totalPages - 1) {
          scrollProgress = maxThumbTravel;
        }
        this.scrollbarThumb.style.width = `${visiblePortion}%`;
        this.scrollbarThumb.style.left = `${scrollProgress}%`;
      })
      .mount();
  }
}

customElements.define('product-slider', ProductCarousel);
